import { FC, useMemo, useState } from "react";
import ChatGptSubmitIcon from "../../../icons/chatgpt-submit";
import ChatGptLoadingIcon from "../../../icons/chatgpt-loading";
import styles from "./index.module.scss";

interface ChatInputProps {
  loading: boolean;
  onSubmit: (text: string) => void;
}

const ChatInput: FC<ChatInputProps> = ({ loading, onSubmit }) => {
  const [input, setInput] = useState("");
  const rows = useMemo(() => {
    const lines = input.split("\n").length;
    return lines > 10 ? 10 : lines;
  }, [input]);

  return (
    <div className={styles.inputContainer}>
      <textarea
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
        }}
        disabled={loading}
        placeholder="输入问题..."
        rows={rows}
      />
      <div className={styles.actions}>
        {loading ? (
          <ChatGptLoadingIcon />
        ) : (
          <div
            className={styles.submit}
            onClick={() => {
              onSubmit(input);
              setInput("");
            }}
          >
            <ChatGptSubmitIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatInput;
